import { createAction } from '@reduxjs/toolkit';
import { alertActions, cdvActions, uiActions, userActions } from '_actions';
import { patientService, pdfService, alService } from '_services';
import { ActionNames, Errors } from '_constants'
import { history } from '_helpers';
import { RouteDefs } from '_constants';
import { noteActions } from './note.actions';

export const patientActions = {



    open: (ptno) => (dispatch, getState) => {
        history.push(RouteDefs.patientCareCenter.path);
        if (ptno !== undefined) {
            let pteroNoteTypes = [1, 2, 3, 4, 5, 6];
            dispatch(patientActions.openRequest(ptno));
            // if the state does not already contain the patient
            if (!getState().entities.patients.hasOwnProperty(ptno)) {
                dispatch(patientActions.loadRequest(ptno));
                patientService.load(ptno)
                    .then(
                        patient => {
                            dispatch(patientActions.loadSuccess(patient));
                            dispatch(patientActions.openSuccess(ptno));
                            if (patient.entities.cdv !== undefined) {
                                Object.keys(patient.entities.cdv)
                                    .filter(key => (patient.entities.cdv[key].status === 1 || patient.entities.cdv[key].status === 5) &&
                                        pteroNoteTypes.includes(patient.entities.cdv[key].noteType) &&
                                        patient.entities.cdv[key].addUser === getState().entities.authentication.user.urno)
                                    .forEach(key => { dispatch(noteActions.openInProgNote(patient.entities.cdv[key].id, ptno, patient.entities.cdv[key].epno)); });
                            }
                            dispatch(patientActions.setTabActive(ptno, 'HOME_' + ptno));
                            dispatch(patientActions.loadFotoEpisodes(ptno));
                        },
                        error => {
                            dispatch(patientActions.loadFailure({ ptno: ptno, error: error }));
                            dispatch(patientActions.openFailure({ ptno: ptno, error: error }));
                            dispatch(alertActions.error(Errors.PATIENT_OPEN_FAILURE));
                        }
                    )
                    .then(() => {
                        dispatch(userActions.saveSession());
                    })
            } else {
                dispatch(patientActions.openSuccess(ptno));

                if (getState().entities.cdv !== undefined) {
                    Object.keys(getState().entities.cdv)
                        .filter(key => getState().entities.cdv[key].ptno === ptno &&
                            (getState().entities.cdv[key].status === 1 || getState().entities.cdv[key].status === 5) &&
                            pteroNoteTypes.includes(getState().entities.cdv[key].noteType) &&
                            getState().entities.cdv[key].addUser === getState().entities.authentication.user.urno)
                        .forEach(key => { dispatch(noteActions.openInProgNote(getState().entities.cdv[key].id, ptno, getState().entities.cdv[key].epno)); });
                }
            }
        }
    },
    openStartNote: (ptno, epno = undefined, aptid = undefined, adtdate = undefined, noteType = undefined) => (dispatch, getState) => {
        history.push(RouteDefs.patientCareCenter.path);
        if (ptno !== undefined) {
            let pteroNoteTypes = [1, 2, 3, 4, 5, 6];
            dispatch(patientActions.openRequest(ptno));
            // if the state does not already contain the patient
            if (!getState().entities.patients.hasOwnProperty(ptno)) {
                dispatch(patientActions.loadRequest(ptno));
                patientService.load(ptno)
                    .then(
                        patient => {
                            let inProgNote = false;
                            dispatch(patientActions.loadSuccess(patient));
                            dispatch(patientActions.openSuccess(ptno));
                            if (patient.entities.cdv !== undefined) {
                                inProgNote = Object.keys(patient.entities.cdv)
                                    .filter(key => patient.entities.cdv[key].status === 1
                                        || patient.entities.cdv[key].status === 3
                                        || patient.entities.cdv[key].status === 5
                                    ).length > 0 ? true : false;
                            }
                            dispatch(patientActions.setTabActive(ptno, 'HOME_' + ptno));
                            if (epno !== undefined && inProgNote === false && !getState().entities.authentication.user.isAide) {
                                dispatch(noteActions.startNote(epno, true, aptid, adtdate, noteType));
                            }
                            if (inProgNote === true) {
                                if (patient.entities.cdv !== undefined) {
                                    Object.keys(patient.entities.cdv)
                                        .filter(key => (patient.entities.cdv[key].status === 1 || patient.entities.cdv[key].status === 5) &&
                                            pteroNoteTypes.includes(patient.entities.cdv[key].noteType) &&
                                            patient.entities.cdv[key].addUser === getState().entities.authentication.user.urno)
                                        .forEach(key => { dispatch(noteActions.openInProgNote(patient.entities.cdv[key].id, ptno, patient.entities.cdv[key].epno)); });
                                }
                            }
                            dispatch(patientActions.loadFotoEpisodes(ptno));
                        },
                        error => {
                            dispatch(patientActions.loadFailure({ ptno: ptno, error: error }));
                            dispatch(patientActions.openFailure({ ptno: ptno, error: error }));
                            dispatch(alertActions.error(Errors.PATIENT_OPEN_FAILURE));
                        }
                    )
                    .then(() => {
                        dispatch(userActions.saveSession());
                    });
            } else {
                dispatch(patientActions.openSuccess(ptno));
                if (getState().entities.cdv !== undefined) {
                    Object.keys(getState().entities.cdv)
                        .filter(key => getState().entities.cdv[key].ptno === ptno &&
                            (getState().entities.cdv[key].status === 1 || getState().entities.cdv[key].status === 5) &&
                            pteroNoteTypes.includes(getState().entities.cdv[key].noteType) &&
                            getState().entities.cdv[key].addUser === getState().entities.authentication.user.urno)
                        .forEach(key => { dispatch(noteActions.openInProgNote(getState().entities.cdv[key].id, ptno, getState().entities.cdv[key].epno)); });
                }
            }
        }
    },
    openEditNote: (ptno, noteId, epno) => (dispatch, getState) => {
        history.push(RouteDefs.patientCareCenter.path);
        if (ptno !== undefined) {
            dispatch(patientActions.openRequest(ptno));
            // if the state does not already contain the patient
            if (!getState().entities.patients.hasOwnProperty(ptno)) {
                dispatch(patientActions.loadRequest(ptno));
                patientService.load(ptno)
                    .then(
                        patient => {
                            dispatch(patientActions.loadSuccess(patient));
                            dispatch(patientActions.openSuccess(ptno));
                            dispatch(noteActions.openInProgNote(noteId, ptno, epno));
                            dispatch(patientActions.loadFotoEpisodes(ptno));
                        },
                        error => {
                            dispatch(patientActions.loadFailure({ ptno: ptno, error: error }));
                            dispatch(patientActions.openFailure({ ptno: ptno, error: error }));
                            dispatch(alertActions.error(Errors.PATIENT_OPEN_FAILURE));
                        }
                    );
            } else {
                dispatch(patientActions.openSuccess(ptno));
                dispatch(noteActions.openInProgNote(noteId, ptno, epno));
            }
        }
    },
    openRequest: createAction(ActionNames.PATIENT_OPEN_REQUEST),
    openSuccess: createAction(ActionNames.PATIENT_OPEN_SUCCESS),
    openFailure: createAction(ActionNames.PATIENT_OPEN_FAILURE),

    loadRequest: createAction(ActionNames.PATIENT_LOAD_REQUEST),
    loadSuccess: createAction(ActionNames.PATIENT_LOAD_SUCCESS),
    loadFailure: createAction(ActionNames.PATIENT_LOAD_FAILURE),

    setActive: createAction(ActionNames.PATIENT_SET_ACTIVE),

    close: (ptno) => (dispatch, getState) => {

        // if the patient we're closing is selected, select the first patient instead
        if (getState().ui.patients.selectedPtno === ptno) {
            var openPatientCount = Object.keys(getState().entities.patients).length;
            if (openPatientCount > 1) {
                var nextPtno = Object.keys(getState().entities.patients)
                    .sort((a, b) => {
                        if (getState().entities.patients[a].lastName === getState().entities.patients[b].lastName) {
                            if (getState().entities.patients[a].firstName === getState().entities.patients[b].firstName) {
                                return getState().entities.patients[a].id > getState().entities.patients[b].id ? 1 : -1;
                            } else {
                                return getState().entities.patients[a].firstName.localeCompare(getState().entities.patients[b].firstName);
                            }
                        } else {
                            return getState().entities.patients[a].lastName.localeCompare(getState().entities.patients[b].lastName)
                        }
                    })
                    .find(key => getState().entities.patients[key].id !== ptno);
                dispatch(patientActions.setActive(parseInt(nextPtno)));
            } else if (openPatientCount === 1) {
                dispatch(uiActions.changeRoute(RouteDefs.therapistDashboard.path));
                history.push(RouteDefs.therapistDashboard.path);
            }
        }

        // close all the patient sepecific tabs
        Object.keys(getState().ui.patientTabs)
            .filter(x => getState().ui.patientTabs[x].ptno === ptno)
            .sort((a, b) => {
                return getState().ui.patientTabs[a].type === "HOME" ? 1 : -1;
            })
            .forEach(x => {
                dispatch(patientActions.closeTab({ tabId: getState().ui.patientTabs[x].id, ptno, noteId: getState().ui.patientTabs[x].noteId }));
            })


        dispatch(patientActions.closeSuccess(ptno));
    },
    closeSuccess: createAction(ActionNames.PATIENT_CLOSE_SUCCESS),

    // usePeds: (epno, ptno, usePeds) => (dispatch, getState) => {
    //     dispatch(patientActions.setUsePedsRequest({ epno, usePeds }));

    //     patientService.setUsePeds(epno, usePeds)
    //         .then(
    //             () => {
    //                 dispatch(patientActions.setUsePedsSuccess({ epno, usePeds }))
    //                 let isScribe = getState().ui.admissions[epno].isScribe;

    //                 if (isScribe) {
    //                     let thurno = getState().ui.admissions[epno].isScribeTHURNO;
    //                     dispatch(noteActions.startNoteScribe({ epno, thurno }));
    //                 }
    //                 else {
    //                     dispatch(noteActions.startNote({ epno }));
    //                 }
    //             }
    //             ,
    //             error => {
    //                 dispatch(patientActions.updatePatientNotesFailure({ epno, usePeds }));
    //                 dispatch(alertActions.error(Errors.PATIENT_USE_PEDS_FAILURE));
    //             }
    //         )
    // },
    // setUsePedsRequest: createAction(ActionNames.PATIENT_USE_PEDS_REQUEST),
    // setUsePedsSuccess: createAction(ActionNames.PATIENT_USE_PEDS_SUCCESS),
    // setUsePedsFailure: createAction(ActionNames.PATIENT_USE_PEDS_FAILURE),

    setTabActive: (ptno, selectedTab, refreshPdf) => (dispatch, getState) => {
        dispatch(patientActions.setTabActiveRequest({ ptno, selectedTab }));

        if (refreshPdf && getState().ui.patientTabs[selectedTab].type === "PDF" && getState().ui.patientTabs[selectedTab].noteSource === 1) {
            dispatch(patientActions.loadPdfRequest());
            var noteId = getState().ui.patientTabs[selectedTab].noteId
            //null check cause I'm paranoid 
            var docRenderType = getState().ui.patientTabs[selectedTab].docRenderType === undefined ? 1 : getState().ui.patientTabs[selectedTab].docRenderType;
            pdfService.load(noteId, docRenderType)
                .then(
                    noteData => {
                        dispatch(patientActions.loadPdfSuccess(noteData, true));
                        dispatch(patientActions.openPdfSuccess(noteId, true));
                    },
                    error => {
                        dispatch(patientActions.loadPdfFailure({ noteId: noteId, error: error }));
                        dispatch(patientActions.openPdfFailure({ noteId: noteId, error: error }));
                        dispatch(alertActions.error(Errors.PATIENT_PDF_OPEN_FAILURE));
                    }
                );
        }
        dispatch(patientActions.setTabActiveSuccess({ ptno, selectedTab }));
    },

    setTabActiveRequest: createAction(ActionNames.PATIENT_SET_TAB_ACTIVE_REQUEST),
    setTabActiveSuccess: createAction(ActionNames.PATIENT_SET_TAB_ACTIVE_SUCCESS),
    setTabActiveFailure: createAction(ActionNames.PATIENT_SET_TAB_ACTIVE_FAILURE),

    closeTab: createAction(ActionNames.PATIENT_CLOSE_TAB),

    refreshAdmissions: (ptno) => dispatch => {
        dispatch(patientActions.refreshAdmissionsRequest({ ptno }));

        patientService.refreshAdmissions(ptno)
            .then(
                patient => {
                    dispatch(patientActions.refreshAdmissionsSuccess(patient));
                }
                ,
                error => {
                    dispatch(patientActions.refreshAdmissionsFailure({ ptno: ptno, error: error }));
                    dispatch(alertActions.error(Errors.PATIENT_REFRESH_ADMISSIONS_FAILURE));
                }
            );
    },
    refreshAdmissionsRequest: createAction(ActionNames.PATIENT_REFRESH_ADMISSIONS_REQUEST),
    refreshAdmissionsSuccess: createAction(ActionNames.PATIENT_REFRESH_ADMISSIONS_SUCCESS),
    refreshAdmissionsFailure: createAction(ActionNames.PATIENT_REFRESH_ADMISSIONS_FAILURE),

    refreshScans: (ptno) => dispatch => {
        dispatch(patientActions.refreshScansRequest({ ptno }));

        patientService.refreshScans(ptno)
            .then(
                patient => {
                    dispatch(patientActions.refreshScansSuccess(patient));
                }
                ,
                error => {
                    dispatch(patientActions.refreshScansFailure({ ptno: ptno, error: error }));
                    dispatch(alertActions.error(Errors.PATIENT_REFRESH_SCANS_FAILURE));
                }
            );
    },
    refreshScansRequest: createAction(ActionNames.PATIENT_REFRESH_SCANS_REQUEST),
    refreshScansSuccess: createAction(ActionNames.PATIENT_REFRESH_SCANS_SUCCESS),
    refreshScansFailure: createAction(ActionNames.PATIENT_REFRESH_SCANS_FAILURE),


    updatePatientNotes: (ptno, notes) => dispatch => {
        dispatch(patientActions.updatePatientNotesRequest({ ptno }));

        patientService.updatePatientNotes(ptno, notes)
            .then(
                () => { dispatch(patientActions.updatePatientNotesSuccess({ ptno: ptno, notes: notes })) }
                ,
                error => {
                    dispatch(patientActions.updatePatientNotesFailure({ ptno: ptno, error: error }));
                    dispatch(alertActions.error(Errors.PATIENT_UPDATE_NOTES_FAILURE));
                }
            );
    },
    updatePatientNotesRequest: createAction(ActionNames.PATIENT_UPDATE_NOTES_REQUEST),
    updatePatientNotesSuccess: createAction(ActionNames.PATIENT_UPDATE_NOTES_SUCCESS),
    updatePatientNotesFailure: createAction(ActionNames.PATIENT_UPDATE_NOTES_FAILURE),

    updateAdmissionContrain: (epno, contrain) => dispatch => {
        dispatch(patientActions.updateAdmissionContrainRequest({ epno }));

        patientService.updatePatientContrain(epno, contrain)
            .then(
                () => { dispatch(patientActions.updateAdmissionContrainSuccess({ epno: epno, contrain: contrain })) }
                ,
                error => {
                    dispatch(patientActions.updateAdmissionContrainFailure({ epno: epno, error: error }));
                    dispatch(alertActions.error(Errors.PATIENT_UPDATE_CONTRAIN_FAILURE));
                }
            );
    },
    updateAdmissionContrainRequest: createAction(ActionNames.PATIENT_UPDATE_CONTRAIN_REQUEST),
    updateAdmissionContrainSuccess: createAction(ActionNames.PATIENT_UPDATE_CONTRAIN_SUCCESS),
    updateAdmissionContrainFailure: createAction(ActionNames.PATIENT_UPDATE_CONTRAIN_FAILURE),



    enableRtmForAdmission: (epno, getState) => dispatch => {
        dispatch(patientActions.enableRtmForAdmissionRequest({ epno }));

        patientService.enableRtm(epno)
            .then(
                () => {
                    dispatch(patientActions.enableRtmForAdmissionSuccess({ epno }));
                }
                ,
                error => {
                    dispatch(patientActions.enableRtmForAdmissionFailure({ epno: epno, error: error }));
                    dispatch(alertActions.error(Errors.PATIENT_ENABLE_RTM_FAILURE));
                }
            );
    },
    enableRtmForAdmissionRequest: createAction(ActionNames.PATIENT_ENABLE_RTM_REQUEST),
    enableRtmForAdmissionSuccess: createAction(ActionNames.PATIENT_ENABLE_RTM_SUCCESS),
    enableRtmForAdmissionFailure: createAction(ActionNames.PATIENT_ENABLE_RTM_FAILURE),


    categoryChange: createAction(ActionNames.PATIENT_CATEGORY_CHANGE),
    toggleAdmissionVisibility: createAction(ActionNames.PATIENT_ADMISSION_VISIBILITY_TOGGLE),
    toggleCdvVisibility: createAction(ActionNames.PATIENT_CDV_VISIBILITY_TOGGLE),
    toggleFotoPanelVisibility: createAction(ActionNames.PATIENT_FOTO_PANEL_VISIBILITY_TOGGLE),
    toggleRtmVisibility: createAction(ActionNames.PATIENT_RTM_VISIBILITY_TOGGLE),

    openPdf: (noteId, openTab = true, docRenderType = 1) => (dispatch, getState) => {
        let ptno = getState().entities.cdv[noteId].ptno;
        var noteType = getState().entities.cdv[noteId].noteType;
        var noteSource = getState().entities.masterData.PTMASTERNOTETYPES[noteType].MTSONO;


        dispatch(patientActions.openPdfRequest({ noteId, ptno, noteSource, openTab, docRenderType }));
        if (!getState().entities.pdfs.hasOwnProperty(noteId) || noteSource === 1) {
            dispatch(patientActions.loadPdfRequest());
            pdfService.load(noteId, docRenderType)
                .then(
                    noteData => {
                        dispatch(patientActions.loadPdfSuccess(noteData, openTab));
                        dispatch(patientActions.openPdfSuccess(noteId, openTab));
                    },
                    error => {
                        dispatch(patientActions.loadPdfFailure({ noteId: noteId, error: error }));
                        dispatch(patientActions.openPdfFailure({ noteId: noteId, error: error }));
                        dispatch(alertActions.error(Errors.PATIENT_PDF_OPEN_FAILURE));
                    }
                );
        } else {
            dispatch(patientActions.openPdfSuccess(noteId, openTab));
        }
    },
    openPdfRequest: createAction(ActionNames.PATIENT_PDF_OPEN_REQUEST),
    openPdfSuccess: createAction(ActionNames.PATIENT_PDF_OPEN_SUCCESS),
    openPdfFailure: createAction(ActionNames.PATIENT_PDF_OPEN_FAILURE),

    loadPdfRequest: createAction(ActionNames.PATIENT_PDF_LOAD_REQUEST),
    loadPdfSuccess: createAction(ActionNames.PATIENT_PDF_LOAD_SUCCESS),
    loadPdfFailure: createAction(ActionNames.PATIENT_PDF_LOAD_FAILURE),

    openAl: (epno, ptno, openTab = true) => (dispatch, getState) => {
        dispatch(patientActions.openAlRequest({ epno, openTab, ptno }));
        dispatch(patientActions.loadAlRequest({ epno, openTab, ptno }));
        alService.load(epno)
            .then(
                data => {
                    dispatch(patientActions.loadAlSuccess({ epno, openTab, ptno, data }));
                    dispatch(patientActions.openAlSuccess({ epno, openTab, ptno }));
                },
                error => {
                    dispatch(patientActions.loadAlFailure({ epno, openTab, ptno, error }));
                    dispatch(patientActions.openAlFailure({ epno, openTab, ptno, error }));
                    dispatch(alertActions.error(Errors.PATIENT_AL_OPEN_FAILURE));
                }
            );
    },
    openAlRequest: createAction(ActionNames.PATIENT_AL_OPEN_REQUEST),
    openAlSuccess: createAction(ActionNames.PATIENT_AL_OPEN_SUCCESS),
    openAlFailure: createAction(ActionNames.PATIENT_AL_OPEN_FAILURE),

    loadAlRequest: createAction(ActionNames.PATIENT_AL_LOAD_REQUEST),
    loadAlSuccess: createAction(ActionNames.PATIENT_AL_LOAD_SUCCESS),
    loadAlFailure: createAction(ActionNames.PATIENT_AL_LOAD_FAILURE),

    changeAlDisplayMode: createAction(ActionNames.PATIENT_AL_DISPLAY_MODE_CHANGE),


    loadDiary: (ptno) => (dispatch) => {
        dispatch(patientActions.loadDiaryRequest({ ptno }));

        patientService.loadDiary(ptno)
            .then(
                patient => {
                    dispatch(patientActions.loadDiarySuccess(patient));
                }
                ,
                error => {
                    dispatch(patientActions.loadDiaryFailure({ ptno: ptno, error: error }));
                    dispatch(alertActions.error('Failed to refresh diary.'));
                }
            );
    },
    loadDiaryRequest: createAction(ActionNames.PATIENT_DIARY_LOAD_REQUEST),
    loadDiarySuccess: createAction(ActionNames.PATIENT_DIARY_LOAD_SUCCESS),
    loadDiaryFailure: createAction(ActionNames.PATIENT_DIARY_LOAD_FAILURE),

    changeApptHistFilter: createAction(ActionNames.PATIENT_APPT_HIST_FILTER),
    changeApptHistStartDate: createAction(ActionNames.PATIENT_APPT_HIST_START_DATE),
    changeApptHistEndDate: createAction(ActionNames.PATIENT_APPT_HIST_END_DATE),
    changeApptHistSort: createAction(ActionNames.PATIENT_APPT_HIST_SORT),

    togglePeerReviewVisibility: createAction(ActionNames.PATIENT_PEER_REVIEW_VISIBILITY_TOGGLE),

    showSpecialProgReq: createAction(ActionNames.PATIENT_SHOW_SPECIAL_PROG_REQ),
    hideSpecialProgReq: createAction(ActionNames.PATIENT_HIDE_SPECIAL_PROG_REQ),

    saveSpecialProgReq: (epno, type, note) => (dispatch, getState) => {
        let ptno = getState().entities.admissions[epno].ptno;
        dispatch(patientActions.saveSpecialProgReqRequest({ epno }));

        patientService.requestSpecialProg(epno, type, note)
            .then(
                () => {
                    dispatch(patientActions.saveSpecialProgReqSuccess({ epno }));
                    dispatch(patientActions.hideSpecialProgReq({ epno }));
                    dispatch(patientActions.loadPeerReviews(ptno));
                    dispatch(alertActions.successMsg('Specialty Program Request Submitted.'));
                }
                ,
                error => {
                    dispatch(patientActions.saveSpecialProgReqFailure({ epno: epno, error: error }));
                    dispatch(alertActions.error(Errors.PATIENT_SAVE_SPECIAL_PROG_FAILURE));
                }
            );
    },
    saveSpecialProgReqRequest: createAction(ActionNames.PATIENT_SAVE_SPECIAL_PROG_REQ_REQUEST),
    saveSpecialProgReqSuccess: createAction(ActionNames.PATIENT_SAVE_SPECIAL_PROG_REQ_SUCCESS),
    saveSpecialProgReqFailure: createAction(ActionNames.PATIENT_SAVE_SPECIAL_PROG_REQ_FAILURE),

    loadPeerReviews: (ptno) => (dispatch) => {
        dispatch(patientActions.loadPeerReviewsRequest({ ptno }));

        patientService.loadPeerReviews(ptno)
            .then(
                patient => {
                    dispatch(patientActions.loadPeerReviewsSuccess(patient));
                }
                ,
                error => {
                    dispatch(patientActions.loadPeerReviewsFailure({ ptno: ptno, error: error }));
                    dispatch(alertActions.error('Failed to refresh peer reviews.'));
                }
            );
    },
    loadPeerReviewsRequest: createAction(ActionNames.PATIENT_PEER_REVIEWS_LOAD_REQUEST),
    loadPeerReviewsSuccess: createAction(ActionNames.PATIENT_PEER_REVIEWS_LOAD_SUCCESS),
    loadPeerReviewsFailure: createAction(ActionNames.PATIENT_PEER_REVIEWS_LOAD_FAILURE),

    addDiag: (epno, diag, type) => (dispatch) => {
        dispatch(patientActions.addDiagRequest({ epno, diag, type }));

        patientService.addDiag(epno, diag, type)
            .then(
                diags => {
                    dispatch(patientActions.addDiagSuccess(diags));
                }
                ,
                error => {
                    dispatch(patientActions.addDiagFailure({ epno, diag, type, error }));
                    dispatch(alertActions.error('Failed to add diagnosis.'));
                }
            );
    },
    addDiagRequest: createAction(ActionNames.PATIENT_ADD_DIAG_REQUEST),
    addDiagSuccess: createAction(ActionNames.PATIENT_ADD_DIAG_SUCCESS),
    addDiagFailure: createAction(ActionNames.PATIENT_ADD_DIAG_FAILURE),


    removeDiag: (epno, diag, type, id) => (dispatch) => {
        dispatch(patientActions.removeDiagRequest({ epno, diag, type, id }));

        patientService.removeDiag(epno, diag, type)
            .then(
                diags => {
                    dispatch(patientActions.removeDiagSuccess({ epno, diags }));
                }
                ,
                error => {
                    dispatch(patientActions.removeDiagFailure({ epno, diag, type, id, error }));
                    dispatch(alertActions.error('Failed to remove diagnosis.'));
                }
            );
    },
    removeDiagRequest: createAction(ActionNames.PATIENT_REMOVE_DIAG_REQUEST),
    removeDiagSuccess: createAction(ActionNames.PATIENT_REMOVE_DIAG_SUCCESS),
    removeDiagFailure: createAction(ActionNames.PATIENT_REMOVE_DIAG_FAILURE),

    copyAllDiag: (epno) => (dispatch) => {
        dispatch(patientActions.copyAllDiagRequest({ epno }));

        patientService.copyDiags(epno)
            .then(
                diags => {
                    dispatch(patientActions.copyAllDiagSuccess(diags));
                }
                ,
                error => {
                    dispatch(patientActions.copyAllDiagFailure({ epno, error }));
                    dispatch(alertActions.error('Failed to copy all of the diagnosis.'));
                }
            );
    },
    copyAllDiagRequest: createAction(ActionNames.PATIENT_COPY_ALL_DIAG_REQUEST),
    copyAllDiagSuccess: createAction(ActionNames.PATIENT_COPY_ALL_DIAG_SUCCESS),
    copyAllDiagFailure: createAction(ActionNames.PATIENT_COPY_ALL_DIAG_FAILURE),

    updateDiagOnset: (epno, position, type, val) => (dispatch) => {
        dispatch(patientActions.updateDiagOnsetRequest({ epno, position, type, val }));

        patientService.updateDiagOnset(epno, position, type, val)
            .then(
                diags => {
                    dispatch(patientActions.updateDiagOnsetSuccess(diags));
                }
                ,
                error => {
                    dispatch(patientActions.updateDiagOnsetFailure({ epno, position, type, val, error }));
                    dispatch(alertActions.error('Failed to update the diagnosis onset.'));
                }
            );
    },
    updateDiagOnsetRequest: createAction(ActionNames.PATIENT_UPDATE_DIAG_ONSET_REQUEST),
    updateDiagOnsetSuccess: createAction(ActionNames.PATIENT_UPDATE_DIAG_ONSET_SUCCESS),
    updateDiagOnsetFailure: createAction(ActionNames.PATIENT_UPDATE_DIAG_ONSET_FAILURE),

    loadPoc: (ptno) => (dispatch) => {
        dispatch(patientActions.loadPocRequest({ ptno }));

        patientService.loadPoc(ptno)
            .then(
                patient => {
                    dispatch(patientActions.loadPocSuccess(patient));
                }
                ,
                error => {
                    dispatch(patientActions.loadPocFailure({ ptno: ptno, error: error }));
                    dispatch(alertActions.error('Failed to load the POCs.'));
                }
            );
    },
    loadPocRequest: createAction(ActionNames.PATIENT_POC_LOAD_REQUEST),
    loadPocSuccess: createAction(ActionNames.PATIENT_POC_LOAD_SUCCESS),
    loadPocFailure: createAction(ActionNames.PATIENT_POC_LOAD_FAILURE),


    loadSupervisiors: (id, noteType, epno) => (dispatch) => {
        dispatch(patientActions.loadSupervisiorsRequest({ id, noteType, epno }));

        patientService.loadSupervisors(id, noteType, epno)
            .then(
                supervisor => {
                    dispatch(patientActions.loadSupervisiorsSuccess(supervisor));
                }
                ,
                error => {
                    dispatch(patientActions.loadSupervisiorsFailure({ id: id, error: error }));
                    dispatch(alertActions.error('Failed to load the Supervisors.'));
                }
            );
    },
    loadSupervisiorsRequest: createAction(ActionNames.LOAD_SUPERVISOR_REQUEST),
    loadSupervisiorsSuccess: createAction(ActionNames.LOAD_SUPERVISOR_SUCCESS),
    loadSupervisiorsFailure: createAction(ActionNames.LOAD_SUPERVISOR_FAILURE),

    updateSupervisior: (id, noteType, supervisorId, epno, ptno) => (dispatch) => {
        dispatch(patientActions.updateSupervisiorRequest({ id, noteType, supervisorId, epno }));

        patientService.updateSupervisor(id, noteType, supervisorId)
            .then(
                supervisor => {
                    dispatch(cdvActions.refreshCdv(ptno));
                    dispatch(patientActions.updateSupervisiorSuccess({ supervisor, epno }));
                    dispatch(alertActions.successMsg('Supervisor has been updated successfully'));

                }
                ,
                error => {
                    dispatch(patientActions.updateSupervisiorFailure({ id: id, error: error }));
                    dispatch(alertActions.error('Failed to update the Supervisor.'));
                }
            );
    },
    updateSupervisiorRequest: createAction(ActionNames.UPDATE_SUPERVISOR_REQUEST),
    updateSupervisiorSuccess: createAction(ActionNames.UPDATE_SUPERVISOR_SUCCESS),
    updateSupervisiorFailure: createAction(ActionNames.UPDATE_SUPERVISOR_FAILURE),


    loadFotoEpisodes: (ptno) => (dispatch) => {
        dispatch(patientActions.loadFotoEpisodesRequest({ ptno }));

        patientService.loadFotoEpisodes(ptno)
            .then(
                fotoEpisodes => {
                    dispatch(patientActions.loadFotoEpisodesSuccess(fotoEpisodes));
                }
                ,
                error => {
                    dispatch(patientActions.loadFotoEpisodesFailure({ ptno: ptno, error: error }));
                    dispatch(alertActions.error('Failed to load the FOTO episodes.'));
                }
            );
    },
    loadFotoEpisodesRequest: createAction(ActionNames.FOTO_EPISODES_LOAD_REQUEST),
    loadFotoEpisodesSuccess: createAction(ActionNames.FOTO_EPISODES_LOAD_SUCCESS),
    loadFotoEpisodesFailure: createAction(ActionNames.FOTO_EPISODES_LOAD_FAILURE),

    showScribeOptions: (epno) => (dispatch, getState) => {
        let inProgNote = false;
        let keys = Object.keys(getState().entities.cdv);
        keys.forEach(x => {
            if (getState().entities.cdv[x].epno === epno && (getState().entities.cdv[x].status === 1 || getState().entities.cdv[x].status === 5)) {
                dispatch(noteActions.startNoteWarning({ epno: epno, status: 8 }));
                inProgNote = true;
            }
        });

        if (!inProgNote) {
            patientService.getAdmissionTherapists(epno)
                .then(therapists => {
                    dispatch(patientActions.showScribeOptionsSuccess({ therapists, epno }))
                }
                )
        }
    },
    showScribeOptionsSuccess: createAction(ActionNames.SCRIBE_OPTIONS_SHOW),
    hideScribeOptions: createAction(ActionNames.SCRIBE_OPTIONS_HIDE),

    refreshFotoEpisodes: (epno, noteID) => (dispatch) => {
        dispatch(patientActions.refreshFotoEpisodesRequest({ epno, noteID }));

        patientService.refreshFoto(epno, noteID)
            .then(
                fotoRefresh => {

                    dispatch(patientActions.refreshFotoEpisodesSuccess({ fotoRefresh, epno }));
                    if (noteID) {
                        dispatch(patientActions.refreshFotoResponseSuccess(fotoRefresh));
                        dispatch(patientActions.refreshFotoMessuresResponseSuccess({ fotoRefresh, noteID }));
                    }
                    dispatch(alertActions.successMsg('Successfully refreshed FOTO Episode.'));
                }
                ,
                error => {
                    dispatch(patientActions.refreshFotoEpisodesFailure({ epno: epno, error: error }));
                    dispatch(alertActions.error('Failed to refresh the FOTO episodes.'));
                }
            );
    },
    refreshFotoResponseSuccess: createAction(ActionNames.FOTO_RESPONCE_REFRESH_SUCCESS),
    refreshFotoEpisodesRequest: createAction(ActionNames.FOTO_EPISODES_REFRESH_REQUEST),
    refreshFotoEpisodesSuccess: createAction(ActionNames.FOTO_EPISODES_REFRESH_SUCCESS),
    refreshFotoMessuresResponseSuccess: createAction(ActionNames.FOTO_RESPONCE_MESSURE_REFRESH_SUCCESS),
    refreshFotoEpisodesFailure: createAction(ActionNames.FOTO_EPISODES_REFRESH_FAILURE),


    refreshFotoEpisodesForPatient: (ptno) => (dispatch) => {
        dispatch(patientActions.refreshFotoEpisodesForPatientRequest({ ptno }));

        patientService.refreshFotoForPatient(ptno)
            .then(
                fotoRefresh => {
                    dispatch(patientActions.refreshFotoEpisodesForPatientSuccess({ fotoRefresh, ptno }));
                    dispatch(alertActions.successMsg('Successfully refreshed FOTO Episode.'));
                }
                ,
                error => {
                    dispatch(alertActions.error('Failed to refresh the FOTO episodes.'));
                }
            );
    },
    refreshFotoEpisodesForPatientRequest: createAction(ActionNames.FOTO_EPISODES_FOR_PATIENT_REFRESH_REQUEST),
    refreshFotoEpisodesForPatientSuccess: createAction(ActionNames.FOTO_EPISODES_FOR_PATIENT_REFRESH_SUCCESS),
    refreshFotoEpisodesForPatientFailure: createAction(ActionNames.FOTO_EPISODES_FOR_PATIENT_REFRESH_FAILURE),

    changeFotoClaimStatus: (epno, unclaimEpisodeId, claimEpisodeId) => (dispatch, getState) => {
        dispatch(patientActions.changeFotoClaimStatusRequest({ epno, unclaimEpisodeId, claimEpisodeId }));

        patientService.changeFotoClaimStatus(epno, unclaimEpisodeId, claimEpisodeId)
            .then(
                response => {
                    dispatch(patientActions.changeFotoClaimStatusSuccess({ epno, response }));
                    if (unclaimEpisodeId && claimEpisodeId) {
                        dispatch(alertActions.successMsg('Successfully changed FOTO Episode.'));
                    }
                    else if (unclaimEpisodeId) {
                        dispatch(alertActions.successMsg('Successfully released FOTO Episode.'));
                    }
                    else if (claimEpisodeId) {
                        dispatch(alertActions.successMsg('Successfully claimed FOTO Episode.'));
                    }
                    if (getState().entities.admissions[epno] && getState().entities.admissions[epno].ptno) {
                        dispatch(cdvActions.refreshCdv(getState().entities.admissions[epno].ptno));
                    }
                }
                ,
                error => {
                    dispatch(patientActions.changeFotoClaimStatusFailure({ epno, unclaimEpisodeId, claimEpisodeId, error }));
                    dispatch(alertActions.error('Failed to change the FOTO claim status.'));
                }
            );
    },
    changeFotoClaimStatusRequest: createAction(ActionNames.FOTO_CLAIM_STATUS_CHANGE_REQUEST),
    changeFotoClaimStatusSuccess: createAction(ActionNames.FOTO_CLAIM_STATUS_CHANGE_SUCCESS),
    changeFotoClaimStatusFailure: createAction(ActionNames.FOTO_CLAIM_STATUS_CHANGE_FAILURE),


    openHEP: (epno) => (dispatch) => {
        dispatch(patientActions.openHEPRequest({ epno }));
        patientService.openHEP(epno)
            .then(
                response => {
                    dispatch(patientActions.openHEPSuccess({ epno, response }));
                    if (response.entities.admissions[epno].hepUrl) {
                        window.open(response.entities.admissions[epno].hepUrl);
                    } else {
                        dispatch(alertActions.error(Errors.PATIENT_OPEN_HEP_FAILURE));
                    }
                }
                ,
                error => {
                    dispatch(patientActions.openHEPFailure({ epno, error }));
                    dispatch(alertActions.error(Errors.PATIENT_OPEN_HEP_FAILURE));
                }
            );

    },
    openHEPRequest: createAction(ActionNames.PATIENT_OPEN_HEP_REQUEST),
    openHEPSuccess: createAction(ActionNames.PATIENT_OPEN_HEP_SUCCESS),
    openHEPFailure: createAction(ActionNames.PATIENT_OPEN_HEP_FAILURE),


    createRtmNote: (epno, rtmDetails, rtm98975Date, rtm98975, rtm98975Assist, rtm98977Date, rtm98977, rtm98980Date, rtm98980, rtm98980Assist, rtm98981Date, rtm98981, rtm98981Assist) => (dispatch, getState) => {
        dispatch(patientActions.createRtmNoteRequest({ epno }));

        patientService.createRtm(epno, rtmDetails, rtm98975Date, rtm98975, rtm98975Assist, rtm98977Date, rtm98977, rtm98980Date, rtm98980, rtm98980Assist, rtm98981Date, rtm98981, rtm98981Assist)
            .then(
                () => {
                    dispatch(patientActions.createRtmNoteSuccess({ epno }));
                    dispatch(alertActions.success('Successfully created the RTM Note'));
                    dispatch(patientActions.refreshScans(getState().ui.patients.selectedPtno));
                }
                ,
                error => {
                    dispatch(patientActions.createRtmNoteFailure({ epno: epno, error: error }));
                    dispatch(alertActions.error(Errors.PATIENT_CREATE_RTM_NOTE_FAILURE));
                }
            );
    },
    createRtmNoteRequest: createAction(ActionNames.PATIENT_CREATE_RTM_NOTE_REQUEST),
    createRtmNoteSuccess: createAction(ActionNames.PATIENT_CREATE_RTM_NOTE_SUCCESS),
    createRtmNoteFailure: createAction(ActionNames.PATIENT_CREATE_RTM_NOTE_FAILURE),


}
